import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from '../anonymizingBaseQuery'
import prepareAuthHeader from '../headers'
import fastApiParamsSerializer from '../paramsSerializer'

const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.serviceUrls.ticketing,
  prepareHeaders: prepareAuthHeader,
  paramsSerializer: fastApiParamsSerializer
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'ticketingApi',
  baseQuery,
  endpoints: () => ({})
})
